<script lang="ts">
	import type { FileModel } from '@app/models/api/FileModel';
	import type { ImageModel } from '@app/models/api/ImageModel';
	import { capitalize } from '$lib/utils/strings';
	import Avatar from '$lib/elements/Avatar.svelte';
	import ButtonBoxPrimaryLight from '$lib/elements/buttons/variants/ButtonBoxPrimaryLight.svelte';
	import ButtonBox from '$lib/elements/buttons/variants/ButtonBox.svelte';
	import MediaBlock from '$lib/elements/MediaBlock.svelte';
	import { downloadFile } from '@app/services/files';

	export let avatar: ImageModel;
	export let firstName: string = null;
	export let lastName: string = null;
	export let job: string = null;
	export let cv: FileModel;
	export let linkedIn: string;
</script>

<MediaBlock classNames="gap-3">
	<svelte:fragment slot="start">
		{#if avatar}
			<Avatar imageUrl={avatar.url} alt={avatar.title} />
		{/if}
	</svelte:fragment>
	<div class="flex flex-col gap-3">
		<div class="font-bold">
			<div>{capitalize(firstName)} <span class="uppercase">{capitalize(lastName)}</span></div>
			<div class="font-light mt-2">{capitalize(job)}</div>
		</div>
		<div class="flex gap-3">
			{#if cv && cv.url}
				<ButtonBoxPrimaryLight
					props={{
						label: 'CV',
						iconLeft: 'download'
					}}
					on:click={() => downloadFile(cv)}
				/>
			{/if}
			{#if linkedIn}
				<ButtonBox
					props={{
						iconLeft: 'linkedin',
						classNames: 'bg-linked-in text-white',
						href: linkedIn,
						hrefTarget: 'blank'
					}}
				/>
			{/if}
		</div>
	</div>
</MediaBlock>
